import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import directContact from "../../../assets/clientDashboard/direct-contact.svg"
import verified from "../../../assets/clientDashboard/verified-number.svg"
import contactOpen from "../../../assets/clientDashboard/contacts-open.svg"

const QualityDemographic = ({ dashboardData }) => {
  const { t } = useTranslation();

  const qualityData = useMemo(() => {
    const defaultQuality = [
      {
        id: 1,
        title: t("dashboard.clientDashboard.qualityDb.directContact"),
        value: "420/600",
        trend: "up",
        color: "bg-secondary",
        icon: (
          <img src={directContact} alt="directContact" />
        ),
      },
      {
        id: 2,
        title: t("dashboard.clientDashboard.qualityDb.verifiedMobile"),
        value: "250/600",
        trend: "down",
        color: "bg-primary",
        icon: (
          <img src={verified} alt="verified" />
        ),
      },
      {
        id: 3,
        title: t("dashboard.clientDashboard.qualityDb.followUpCalls"),
        value: "550/600",
        trend: "up",
        color: "bg-icon",
        icon: (
         <img src={contactOpen} alt="contactOpen" />
        ),
      },
    ];

    return defaultQuality;
  }, [t]);

  const demographicData = useMemo(() => {
    const defaultDemographic = [
      { city: "Bogotá", percentage: 24.33 },
      { city: "Medellín", percentage: 23.83 },
      { city: "Oaxa", percentage: 21.33 },
      { city: "Lima", percentage: 16.17 },
      { city: "Buenos aires", percentage: 14.33 },
    ];

    if (
      dashboardData?.demographics &&
      Array.isArray(dashboardData.demographics)
    ) {
      return dashboardData.demographics.map((d) => ({
        city: d.city || d.label || "Unknown",
        percentage: d.percentage || 0,
      }));
    }

    return defaultDemographic;
  }, [dashboardData]);

  return (
    <div className="bg-[#F8FAFF] rounded-[20px] p-6 shadow-sm border border-[#E3E8F0] mb-8">
      <div className="flex flex-col lg:flex-row gap-12">
        {/* Quality DB Section */}
        <div className="flex-1">
          <h3 className="text-[28px] font-bold text-[#051D42] mb-6">
            Quality DB
          </h3>
          <div className="space-y-4">
            {qualityData.map((item) => (
              <div
                key={item.id}
                className="bg-white rounded-[12px] p-4 flex items-center shadow-sm border border-[#E3E8F0]"
              >
                <div
                  className={`${item.color} p-3 rounded-full mr-5 flex items-center justify-center shrink-0`}
                >
                  {item.icon}
                </div>
                <div className="flex-1">
                  <p className="text-[#051D42] font-semibold text-sm leading-tight">
                    {item.title}
                  </p>
                  <div className="flex items-center mt-1">
                    <span
                      className={`${item.trend === "up" ? "text-[#48BB78]" : "text-[#F56565]"} text-[10px] mr-1`}
                    >
                      {item.trend === "up" ? "▲" : "▼"}
                    </span>
                    <span className="text-primary text-sm">
                      {item.value}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Demographic Section */}
        <div className="flex-1">
          <h3 className="text-[28px] font-bold text-[#051D42] mb-6">
            Demographic
          </h3>
          <div className="space-y-6">
            {demographicData.map((item, index) => (
              <div key={index}>
                <div className="flex justify-between items-center mb-1.5 px-0.5">
                  <span className="text-primary font-semibold text-xs">
                    {item.city}
                  </span>
                  <span className="text-primary text-xs">
                    {item.percentage}%
                  </span>
                </div>
                <div className="w-full bg-[#E2E8F0] rounded-full h-[6px]">
                  <div
                    className="bg-[#136BF0] h-[6px] rounded-full transition-all duration-1000"
                    style={{ width: `${item.percentage}%` }}
                  ></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default QualityDemographic;
